import React, { useState } from 'react'

import {
    StyleSheet,
    View,
    Text,
    TouchableOpacity,
    ScrollView
} from 'react-native'

import {
    adaptive, typography, colors
} from '@sart/styles'

import {
    Space,
    Button,
    Select,
} from '@sart/components'

import { useContent } from '@sart/content'

import client, { useClient } from '@sart/client'

import { testID } from '@sart/utilities'

import { useFormik } from 'formik'
import * as Yup from 'yup'

export default function PayBill(props) {
    const { navigation, route } = props
    const content = useContent()

    const {
        cache: {
          storedPayment,
          cachedPayment,

        } = {}
      } = useClient()

    var amount = "£24.77"
    let paymentMethod

    if (cachedPayment !== undefined) {
        paymentMethod = cachedPayment
      } else if (paymentMethod === undefined && storedPayment !== undefined) {
        paymentMethod = storedPayment
        paymentMethod.method = 'storedDetails'
      } else {
        paymentMethod = route.params?.paymentMethod
      }
      
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            totalAmount: undefined,
            ...props.initialValues
        },
        validationSchema: Yup.object().shape({
            totalAmount: Yup.string().trim().required(content.forms.required),
        }),
        onSubmit: handleCheckout
    })

    function handleCheckout() {
        navigation.navigate('Checkout')
    }
    
    return (
        <ScrollView>
            <View style={styles.container}>
                <Space height={24} />
                <Text style={styles.amountDueText}>{content.dashboard.amountDue}: {amount}</Text>

                <Space height={24} />

                <Select
                    label={content.payBill.selectAmount}
                    value={formik.values.totalAmount}
                    placeholder={content.payBill.selectAmount}
                    options={[
                        { value: '£5', label: "£5" },
                        { value: '£10', label: "£10" },
                        { value: '£20', label: "£20" },
                        { value: '£50', label: "£50" },
                        { value: '£100', label: "£100" },
                        { value: 'FullBill', label: content.payBill.fullAmount },
                    ]}
                    onChange={(option) => formik.handleChange('totalAmount')(option.value)}
                    onOptionChange={option => {
                        formik.handleChange('totalAmount')(option.value)
                    }}
                    error={formik.touched.totalAmount && formik.errors.totalAmount}
                    labelStyle={styles.label}
                    style={styles.selectContainer}
                    containerStyle={styles.selectContainer}
                    placeholderColor={colors.srTextInput}
										injectedContent={content}
                />

                <Space height={24} />

                <Button 
                    title={content.navigation.checkout}
                    onPress={handleCheckout}
                    style={styles.button}
                    titleStyle={styles.buttonTitle}
                    {...testID('buildPlanButton')}
                />
            </View>
        </ScrollView>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        ...adaptive.wrapperPadding,
    },
    amountDueText: {
        ...typography.lightbold,
        fontSize: 22,
        color: colors.srDarkGreen
    },
    labelStyle: {
        color: colors.srDarkGreen,
        fontSize: 20,
        ...typography.lightbold
    },
    label: {
        ...typography.demi,
        color: colors.srDarkGreen,
    },
    selectContainer: {
        borderColor: colors.srGreen,
        borderWidth: 1,
        borderRadius: 4
    },
    button: {
        backgroundColor: colors.srDarkGreen
      },
      buttonTitle: {
        ...typography.bold, 
        fontSize: 18, 
        color: colors.white
      }
})
